export class ComponentValidationResult {
	isValid: boolean = true;
	errorMessages: string[] = [];
	// Confirm - whether to display the error as a confirmation prompt.
	confirm: boolean = false;
	confirmErrorMessageIndex: number = 0;
}
